module.exports = __webpack_public_path__ + "img/1507064048.c59de28d.jpg";